import { connect } from 'react-redux'
import * as actions from './actions'

const mapStateToProps = ({ showHidePasswordInputs }) => ({
  inputState: showHidePasswordInputs
})

export default connect(mapStateToProps, actions)
